import {SuccessCode} from '../../app/types';
import {SuccessResetPassword} from './components/success/SuccessResetPassword';
import {SuccessSubscribe} from './components/success/SuccessSubscribe';
import {SuccessComponent} from './type';

export const successComponents: {[key in SuccessCode]: SuccessComponent} = {
  [SuccessCode.ResetPassword]: SuccessResetPassword,
  [SuccessCode.Subscribe]: SuccessSubscribe,
};
